import { Box, Button } from "@mui/material";
import React from "react";
import { IButton } from "./IButton";

import "./button.css";
export default function CustomisedButton({
  title,
  disable,
  onClick,
  type = "submit",
}: IButton) {
  return (
    <Box textAlign="center">
      <Button
        disabled={disable}
        type={type}
        className={`btnClass  ${disable ? "disabledBtn " : " SuccessDefault"}`}
        fullWidth
        sx={{
          height: "42px",
          color: "#fff !important",
          paddingX: "10px !important",
        }}
        onClick={() => onClick()}
      >
        <b>{title}</b>
      </Button>
    </Box>
  );
}
